import {subCategoryObject} from "@/content/services/2";
import ServiceSubCategoryPage from "@/ui/widgets/service-subcategory-page";

export default function Category2Service2Page() {
    const { category2Service2: subCategory } = subCategoryObject;
    return (<ServiceSubCategoryPage subCategory={subCategory} />)
}
